export default {
	laitmaternel: {
		image: 'laitmaternel.png',
		title: 'Lait maternel'
	},
	lait1age: {
		image: 'lait1age.png',
		title: 'Lait 1<sup>er</sup> âge'
	},
	lait2age: {
		image: 'lait2age.png',
		title: 'Lait 2<sup>ème</sup> âge'
	},
	eaufievre: {
		image: 'eau.png',
		title: 'Eau minérale (complément si fièvre ou forte chaleur)'
	},
	pureepommedeterre: {
		image: 'pureepommedeterre.png',
		title: 'Purée de pomme de terre'
	},
	pureelegumes: {
		image: 'pureelegumes.png',
		title: 'Légumes en purée ou cuits et mixés'
	},
	cerealesansgluten: {
		image: 'cerealesansgluten.png',
		title: 'Céréales sans gluten (farines infantiles)'
	},
	fruitsmurs: {
		image: 'fruitsmurs.png',
		title: 'Fruits très mûrs cuits ou mixés'
	},
	yaourt: {
		image: 'yaourt.png',
		title: 'Yaourt ou fromage blanc nature'
	},
	viandepoissonhachee10g: {
		image: 'viandehachee.png',
		title: 'Viande ou poisson haché (10g/j ou 2 cuillères à café)'
	},
	viandehachee10g: {
		image: 'viandehachee.png',
		title: 'Viande hachée (10g/j ou 2 cuillères à café)'
	},
	poissonhachee10g: {
		image: 'poissonhachee.png',
		title: 'Poisson haché (10g/j ou 2 cuillères à café)'
	},
	viandepoissonhacheoeuf20g: {
		image: 'poissonhachee.png',
		title: 'Viande ou poisson haché (20g/j ou 4 cuillères à café) ou 1/3 d\'œuf'
	},
	viandehachee20g: {
		image: 'viandehachee.png',
		title: 'Viande hachée (20g/j ou 4 cuillères à café)'
	},
	poissonhachee20g: {
		image: 'poissonhachee.png',
		title: 'Poisson haché (20g/j ou 4 cuillères à café)'
	},
	viandepoissonhacheoeuf30g: {
		image: 'oeuf.png',
		title: 'Viande ou poisson haché (30g/j ou 6 cuillères à café) ou 1/2 d\'œuf'
	},
	viandehachee30g: {
		image: 'viandehachee.png',
		title: 'Viande hachée (30g/j ou 6 cuillères à café)'
	},
	poissonhachee30g: {
		image: 'poissonhachee.png',
		title: 'Poisson haché (30g/j ou 6 cuillères à café)'
	},
	semoule: {
		image: 'semoule.png',
		title: 'Semoule'
	},
	riz: {
		image: 'riz.png',
		title: 'Riz'
	},
	pain: {
		image: 'pain.png',
		title: 'Pain'
	},
	oeufdur3: {
		image: 'oeuf.png',
		title: 'Œuf dur (1/3 d’un œuf)'
	},
	oeufdur2: {
		image: 'oeuf.png',
		title: 'Œuf dur (1/2 d’un œuf)'
	},
	oeufdur: {
		image: 'oeuf.png',
		title: '1 œuf'
	},
	patesfines: {
		image: 'patesfines.png',
		title: 'Pâtes fines'
	},
	legumesecrases: {
		image: 'legumesecrases.png',
		title: 'Légumes écrasés ou en morceaux'
	},
	fruitsmorceaux: {
		image: 'fruitsmorceaux.png',
		title: 'Fruits en morceaux'
	},
	fruitsetlegumes: {
		image: 'fruitsetlegumes.png',
		title: 'Au moins 5 fruits et légumes par jour'
	},
	produitslaitiers: {
		image: 'produitslaitiers.png',
		title: '3 ou 4 produits laitiers par jour'
	},
	feculents: {
		image: 'feculents.png',
		title: 'Des féculents à chaque repas selon l’appétit'
	},
	viandepoisson50goeuf: {
		image: 'viande.png',
		title: 'Viande ou poisson haché (50g/j) ou 1 œuf'
	},
	viandepoissonhacheoeuf1e2fois: {
		image: 'poisson.png',
		title: 'Viande ou poisson haché (1 à 2 fois/j) ou 1 œuf'
	},
	eau: {
		image: 'eau.png',
		title: 'Eau minérale'
	},
	oeuf100g: {
		image: 'oeuf100g.png',
		title: 'Viande ou poisson haché (100g/j) ou 2 œufs'
	}
};
